var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFaviconNavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130.4 170",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#003057",
    d: "M73.6,85l50.9-50.9c5.8-5.8,7.5-14.2,4.3-21.8C125.7,4.7,118.6,0,110.4,0H20C9,0,0,9,0,20V150 c0,11,9,20,20,20h90.4c8.2,0,15.3-4.7,18.4-12.3c3.1-7.6,1.5-15.9-4.3-21.8L73.6,85z M118.9,153.5c-1.5,3.5-4.6,5.6-8.5,5.6H20 c-5,0-9.1-4.1-9.1-9.1V20c0-5,4.1-9.1,9.1-9.1h90.4c3.8,0,7,2.1,8.5,5.6c1.5,3.5,0.7,7.3-2,10L66,77.4L58,69.4 c-4.2-4.2-9.7-6.5-15.6-6.5S31,65.3,26.9,69.4c-8.6,8.6-8.6,22.6,0,31.2c4.2,4.2,9.7,6.5,15.6,6.5s11.4-2.3,15.6-6.5l7.9-7.9 l50.9,50.9C119.6,146.3,120.3,150,118.9,153.5z M58.3,85l-7.9,7.9c-2.1,2.1-4.9,3.3-7.9,3.3c-3,0-5.8-1.2-7.9-3.3 c-4.4-4.4-4.4-11.5,0-15.9c2.1-2.1,4.9-3.3,7.9-3.3c3,0,5.8,1.2,7.9,3.3L58.3,85L58.3,85L58.3,85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003057",
    d: "M123.9,73.3c-6.5-6.5-17-6.5-23.5,0L88.9,84.8c-0.1,0.1-0.1,0.4,0,0.5l11.5,11.5c6.5,6.5,17,6.5,23.5,0l0,0 C130.3,90.3,130.3,79.8,123.9,73.3L123.9,73.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFaviconNavy);
export default __webpack_public_path__ + "static/media/logo-favicon-navy.1c4109aa.svg";
export { ForwardRef as ReactComponent };